import { createSlice } from "@reduxjs/toolkit";

/* eslint-disable no-param-reassign */
export const sharedSlice = createSlice({
  name: "share",
  initialState: {
    shareProfile: {},
    pxusers: [],
    selectedUser: {},
  },
  reducers: {
    getShareInfo: (state, action) => {
      state.shareProfile = {};
      state.shareProfile = action.payload;
    },
    getpxusers: (state, action) => {
      state.pxusers = [];
      state.pxusers = action.payload;
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = {};
      state.selectedUser = action.payload;
    }
  }
});
export const { getShareInfo, getpxusers, setSelectedUser } = sharedSlice.actions;

export default sharedSlice.reducer;
